<template>
    <div class="sticky_container" data-aos="fade-up">
        <div class="left_area">
            <h2>
                {{ title }} <span v-if="subTitle">{{ subTitle }}</span>
            </h2>
            <p v-html="subText" v-if="subText"></p>
            <div class="app_btn" v-if="appButtons && appButtons.length">
                <a v-for="(btn, index) in appButtons" :key="index" :href="btn.link" target="_blank">
                    <img :src="btn.img" :alt="btn.alt || 'app_img'" />
                </a>
            </div>
            <div class="list_area">
                <ul>
                    <li v-for="(item, index) in leftItems" :key="index" :class="{ active: item.active }">
                        {{ item.text }}
                        <template v-if="isSpecialPage && index === leftItems.length - 1">
                            <h2>
                                {{ secondTitle }} <span v-if="subTitle">{{ subTitle }}</span>
                            </h2>
                            <div class="app_btn" v-if="freeAppButtons">
                                <a v-for="(btn, btnIndex) in freeAppButtons" :key="btnIndex" :href="btn.link" target="_blank">
                                    <img :src="btn.img" :alt="btn.alt || 'app_img'" />
                                </a>
                            </div>
                            <p>주요 특징</p>
                        </template>
                    </li>
                </ul>
            </div>
        </div>
        <div class="right_area">
            <ul>
                <li v-for="(item, index) in rightItems" :key="index">
                    <template v-if="isSpecialPage && index === rightItems.length - 1">
                        <!-- row 구조 -->
                        <template v-if="item.sectionTitle">
                            <h2 class="section_title" style="margin-top: 60px; margin-bottom: 30px">{{ item.sectionTitle }}</h2>
                            <div class="app_btn" v-if="freeAppButtons" style="margin-bottom: 30px">
                                <a v-for="(btn, btnIndex) in freeAppButtons" :key="btnIndex" :href="btn.link" target="_blank">
                                    <img :src="btn.img" :alt="btn.alt || 'app_img'" />
                                </a>
                            </div>
                        </template>
                        <div class="row">
                            <div class="img_box">
                                <img v-if="item.img" :src="item.img" :alt="item.title" />
                            </div>
                            <div class="text_box">
                                <p v-if="item.title" class="title">{{ item.title }}</p>
                                <p v-if="item.description" class="txt" v-html="item.description"></p>
                                <div class="grid-2" v-if="item.cards && item.cards.length">
                                    <div class="card-box" v-for="(card, cardIndex) in item.cards" :key="cardIndex">
                                        <div class="title-area">
                                            <div class="img-box">
                                                <img v-if="card.img" :src="card.img" :alt="card.title || 'Card Image'" />
                                            </div>
                                            <p class="title" v-if="card.title">{{ card.title }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <!-- 기본 info 구조 -->
                        <div class="info">
                            <div class="img_box">
                                <img v-if="item.img" :src="item.img" :alt="item.title" />
                            </div>
                            <div class="img_group" v-if="item.multiimg">
                                <div class="imgs">
                                    <img :src="item.multiimg" alt="" />
                                    <div class="text_wrap">
                                        <p class="imgs_title">리더기 탈부착 지원</p>
                                        <p class="imgs_desc">
                                            당사 안드로이드 H/W와 더불어 사설 태블릿으로도 <br />
                                            사용 가능하며 테이블오더 로만 사용할 경우 <br />
                                            화면 우측 리더기 없이 사용 가능합니다.
                                        </p>
                                    </div>
                                </div>
                                <div class="imgs">
                                    <img :src="item.multiimgs" alt="" />
                                    <div class="text_wrap">
                                        <p class="imgs_title">테이블번호 설정 기능 제공</p>
                                        <p class="imgs_desc">
                                            종업원이 태블릿을 들고 다니면서 <br />
                                            해당 테이블에서 직접 주문을 받는 형태의 <br />
                                            전자메뉴판 기능도 지원합니다.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <p v-if="item.title" class="title">{{ item.title }}</p>
                            <p v-if="item.description" class="txt" v-html="item.description"></p>
                            <ul v-if="item.list && item.list.length">
                                <li v-for="(listItem, listIndex) in item.list" :key="listIndex">
                                    {{ listItem }}
                                </li>
                            </ul>
                            <ul class="shop_list" v-if="item.shoplist && item.shoplist.length">
                                <li v-for="(shopItem, shopIndex) in item.shoplist" :key="shopIndex">
                                    <span v-html="shopItem"></span>
                                </li>
                            </ul>
                            <div v-if="item.colors && item.colors.length" class="color_list">
                                <span v-for="(color, colorIndex) in item.colors" :key="colorIndex" :class="'color ' + color.className"></span>
                                <span v-if="item.customColor" class="etc">{{ item.customColor }}</span>
                            </div>
                            <div v-if="item.subimg" class="gonfalon_img">
                                <img :src="item.subimg" alt="" />
                            </div>
                        </div>
                    </template>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        secondTitle: {
            type: String,
            required: true,
        },
        subTitle: {
            type: String,
            default: '',
        },
        subText: {
            type: String,
            default: '',
        },
        leftItems: {
            type: Array,
            default: () => [],
        },
        rightItems: {
            type: Array,
            default: () => [],
        },
        appButtons: {
            type: Array,
            default: () => [],
        },
        freeAppButtons: {
            type: Array,
            default: () => [],
        },
        isSpecialPage: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        this.initScrollSync();
    },
    beforeUnmount() {
        if (this.scrollSyncHandler) {
            window.removeEventListener('scroll', this.scrollSyncHandler);
        }
    },
    methods: {
        initScrollSync() {
            const leftItems = this.$el.querySelectorAll('.left_area .list_area ul li');
            const rightItems = this.$el.querySelectorAll('.right_area > ul > li');

            if (!leftItems.length || !rightItems.length) return;

            const handleScroll = () => {
                const viewportCenter = window.innerHeight / 2;
                let activeIndex = -1;
                let minDistance = Infinity;

                rightItems.forEach((item, index) => {
                    const rect = item.getBoundingClientRect();
                    const itemCenter = rect.top + rect.height / 2;
                    const distance = Math.abs(itemCenter - viewportCenter);

                    if (distance < minDistance) {
                        minDistance = distance;
                        activeIndex = index;
                    }
                });

                leftItems.forEach((item, index) => {
                    item.classList.toggle('active', index === activeIndex);
                });
            };
            const handleClick = (index) => {
                const targetItem = rightItems[index];
                if (targetItem) {
                    const rect = targetItem.getBoundingClientRect();
                    const scrollY = window.scrollY + rect.top - 120;

                    window.scrollTo({
                        top: scrollY,
                        behavior: 'smooth',
                    });
                }
            };

            leftItems.forEach((item, index) => {
                item.addEventListener('click', () => handleClick(index));
            });

            this.scrollSyncHandler = handleScroll;
            window.addEventListener('scroll', handleScroll);
            handleScroll();
        },
    },
};
</script>

<style lang="scss">
.sticky_container {
    display: flex;
    justify-content: space-between;
    gap: 30px;

    .img_group {
        flex-wrap: wrap;
        display: flex;
        gap: 20px;
        .imgs {
            position: relative;
            flex: 1 0 320px;

            @media screen and (max-width: 1024px) {
              flex: 1 0 240px;
            }
            
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .text_wrap {
                position: absolute;
                top: 30px;
                left: 30px;
                display: flex;
                flex-direction: column;
                gap: 30px;
                width: 80%;

                @media screen and (max-width: 1024px) {
                    top: 20px;
                    left: 20px;
                }

                .imgs_title {
                    color: #fff;
                    font-size: 28px;
                    font-weight: 700;
                    @media screen and (max-width: 1280px) {
                        font-size: 24px;
                    }
                    @media screen and (max-width: 768px) {
                        font-size: 20px;
                    }
                }
                .imgs_desc {
                    font-size: 18px;
                    line-height: 30px;
                    color: #fff;
                    @media screen and (max-width: 1280px) {
                        font-size: 16px;
                        line-height: 1.4;
                        br {
                            display: none;
                        }
                    }
                    @media screen and (max-width: 768px) {
                        font-size: 14px;
                        br {
                            display: none;
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 768px) {
        flex-direction: column;
    }

    .left_area {
        position: sticky;
        top: 120px;
        align-self: flex-start;
        flex: 1 0 240px;

        @media screen and (max-width: 768px) {
            position: inherit;
            flex: 1 0 auto;
        }

        h2 {
            font-size: 50px;
            font-weight: 700;

            @media screen and (max-width: 1280px) {
                font-size: 32px;
            }

            @media screen and (max-width: 768px) {
                font-size: 24px;
            }

            span {
                font-size: 18px;
                margin-left: 16px;

                @media screen and (max-width: 1280px) {
                    font-size: 16px;
                }

                @media screen and (max-width: 768px) {
                    font-size: 14px;
                }
            }
        }

        p {
            margin-top: 30px;
            font-size: 18px;
            color: #333;
            line-height: 30px;

            @media screen and (max-width: 1280px) {
                font-size: 16px;
            }

            @media screen and (max-width: 768px) {
                br {
                    display: none;
                }
            }

            span.accent {
                color: #003cff;
            }
        }

        .app_btn {
            margin-top: 30px;
            display: flex;
            gap: 10px;
        }

        .list_area {
            margin-top: 50px;

            ul li {
                font-size: 18px;
                color: #999;
                list-style: none;
                cursor: pointer;
                font-weight: 500;
                @media screen and (max-width: 1280px) {
                    font-size: 16px;
                }
                @media screen and (max-width: 768px) {
                    font-size: 14px;
                }

                & + li {
                    margin-top: 20px;
                }

                &.active {
                    color: #e61c39;

                    p {
                        color: #e61c39;
                    }
                }

                p {
                    font-size: 18px;
                    color: #999;
                    list-style: none;
                    cursor: pointer;
                    font-weight: 500;
                }
            }

            @media screen and (max-width: 768px) {
                display: none;
            }
        }
    }

    .right_area {
        flex: 0 1 1000px;

        ul li {
            list-style: none;
            padding-bottom: 120px;

            @media screen and (max-width: 768px) {
                padding-block: 30px;
            }

            .row {
                display: flex;
                gap: 50px;

                @media screen and (max-width: 1024px) {
                    flex-direction: column;

                    .img_box {
                        text-align: center;
                    }
                }

                .text_box {
                    flex: 1;

                    .title {
                        font-size: 28px;
                        font-weight: bold;
                        color: #111;

                        @media screen and (max-width: 768px) {
                            font-size: 20px;
                        }
                    }

                    .txt {
                        font-size: 22px;
                        font-weight: bold;
                        color: #111;
                        margin-top: 50px;

                        @media screen and (max-width: 768px) {
                            font-size: 18px;
                        }
                    }

                    .grid-2 {
                        gap: 38px;
                        margin-top: 36px;

                        @media screen and (max-width: 768px) {
                            gap: 20px;
                        }

                        .card-box {
                            padding: 50px 20px;
                            text-align: center;
                            background-color: #fafafa;

                            @media screen and (max-width: 768px) {
                                padding: 30px 10px;
                            }

                            .title-area .title {
                                font-size: 16px;
                                font-weight: normal;
                                color: #333;
                                margin-top: 27px;

                                @media screen and (max-width: 768px) {
                                    font-size: 15px;
                                    word-break: keep-all;
                                }
                            }
                        }
                    }
                }
            }

            .info {
                display: flex;
                flex-direction: column;

                .img_box {
                    display: flex;
                    gap: 26px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .title {
                    margin-top: 40px;
                    font-size: 28px;
                    font-weight: 700;

                    @media screen and (max-width: 768px) {
                        font-size: 20px;
                        margin-top: 20px;
                    }
                }

                .txt {
                    font-size: 18px;
                    line-height: 30px;
                    margin-top: 30px;
                    color: #333;

                    @media screen and (max-width: 768px) {
                        margin-top: 10px;
                        font-size: 16px;
                    }
                }

                .color_list {
                    display: flex;
                    align-items: center;
                    margin-top: 20px;

                    .color {
                        display: inline-block;
                        width: 16px;
                        height: 16px;
                        border-radius: 100%;

                        + .color {
                            margin-left: 12px;
                        }

                        &.light_red {
                            background-color: #eb4e47;
                        }

                        &.red {
                            background-color: #de3d2c;
                        }

                        &.light_blue {
                            background-color: #b1e1e2;
                        }

                        &.orange {
                            background-color: #eb8760;
                        }

                        &.yellow {
                            background-color: #f7b832;
                        }

                        &.pink {
                            background-color: #de6376;
                        }
                    }

                    .etc {
                        margin-left: 16px;
                        font-size: 18px;
                        line-height: 16px;
                        color: #999;
                        @media screen and (max-width: 768px) {
                            font-size: 16px;
                        }
                    }
                }

                ul li {
                    position: relative;
                    padding-left: 10px;
                    margin-top: 30px;
                    font-size: 18px;
                    color: #333;
                    padding-bottom: 0;

                    @media screen and (max-width: 768px) {
                        padding-top: 0;
                        margin-top: 20px;
                        font-size: 16px;
                    }

                    + li {
                        margin-top: 10px;
                    }

                    &::before {
                        content: '';
                        position: absolute;
                        top: calc(1ch - 2px);
                        left: 0;
                        display: block;
                        width: 4px;
                        height: 4px;
                        background-color: #ccc;
                    }
                }

                .shop_list {
                    counter-reset: list-number;

                    li {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        counter-increment: list-number;
                        line-height: 2;
                        padding-left: 0;

                        @media screen and (max-width: 768px) {
                            align-items: flex-start;
                        }

                        &::before {
                            content: '0' counter(list-number);
                            position: initial;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 30px;
                            height: 30px;
                            border-radius: 50%;
                            line-height: 1.2;
                            color: #e61c39;
                            border: 1px solid #e61c39;
                            background-color: #fff;
                            font-weight: bold;
                            flex: none;

                            @media screen and (max-width: 768px) {
                                width: 25px;
                                height: 25px;
                                font-size: 14px;
                            }
                        }

                        span {
                            @media screen and (max-width: 768px) {
                                font-size: 15px;
                            }

                            span {
                                color: #e61c39;
                            }
                        }
                    }
                }

                .gonfalon_img {
                    margin-top: 15px;
                }
            }

            &:last-child {
                padding-bottom: 0;
            }
        }
    }
}
</style>
